module.exports = __webpack_public_path__ + "img/aviation_system2.005b4d2c.jpg";